<template>
  <button
    class="flex items-center gap-1 rounded-full hover:opacity-90"
    :class="className"
    @click="onClick"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "ButtonComp",
  props: {
    className: {
      type: String,
      default: "",
    },
    onClick: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
